export const PURCHASE_ORDER_WORKFLOW_TRANSITIONS = {
  // [ORDER_CREATION, WAITING_FOR_SUPPLIER_AGREEMENT] -> WAITING_FOR_SUPPLIER_AGREEMENT
  SEND_PURCHASE_ORDER: 'send_purchase_order',

  // WAITING_FOR_SUPPLIER_AGREEMENT -> SUPPLIER_AGREEMENT_RECEIVED
  UPLOAD_UNSIGNED_PROFORMA_WAITING_FOR_SUPPLIER_AGREEMENT:
    'upload_unsigned_proforma_waiting_for_supplier_agreement',

  // SUPPLIER_AGREEMENT_RECEIVED -> IN_ADJUSTMENTS
  UPLOAD_UNSIGNED_PROFORMA_SUPPLIER_AGREEMENT_RECEIVED:
    'upload_unsigned_proforma_supplier_agreement_received',

  // IN_ADJUSTMENTS -> IN_ADJUSTMENTS
  UPLOAD_UNSIGNED_PROFORMA_IN_ADJUSTMENTS:
    'upload_unsigned_proforma_in_adjustments',

  // IN_PRODUCTION -> IN_ADJUSTMENTS
  UPLOAD_UNSIGNED_PROFORMA_IN_PRODUCTION:
    'upload_unsigned_proforma_in_production',

  // SUPPLIER_AGREEMENT_RECEIVED -> IN_PRODUCTION
  UPLOAD_SIGNED_PROFORMA_SUPPLIER_AGREEMENT_RECEIVED:
    'upload_signed_proforma_supplier_agreement_received',

  // IN_ADJUSTMENTS -> IN_PRODUCTION
  UPLOAD_SIGNED_PROFORMA_IN_ADJUSTMENTS:
    'upload_signed_proforma_in_adjustments',
} as const;
